'use client';
import { useLocale, useTranslations } from 'next-intl';
import { StarIcon } from '@heroicons/react/24/outline';
import { Button, Link } from '@/components/ui';
import { useEventFollows } from './EventFollowProvider';
export function EventFollowButton({ playerId, label }: { playerId: string; label: string }) {
  const f = useEventFollows();
  const t = useTranslations('Event.follow');
  const locale = useLocale();
  const following = f.playerIds.has(playerId);
  const title = t(following ? 'unfollow' : 'follow', { name: label });
  if (f.unavailable) return null;
  if (f.ready && !f.userId)
    return (
      <Link
        href={`/${locale}/login?redirect=${encodeURIComponent(typeof window === 'undefined' ? `/${locale}` : window.location.pathname + window.location.search)}`}
        aria-label={t('signIn', { name: label })}
        title={t('signIn', { name: label })}
        className="text-muted hover:text-foreground inline-flex min-h-11 min-w-11 shrink-0 items-center justify-center"
      >
        <StarIcon className="size-5" />
      </Link>
    );
  return (
    <Button
      variant="ghost"
      className="min-h-11 min-w-11 shrink-0 p-2"
      aria-label={title}
      title={title}
      aria-pressed={following}
      disabled={!f.ready || f.pending.has(playerId)}
      onClick={() => void f.setFollowing(playerId, !following)}
    >
      <StarIcon className={following ? 'text-warning-emphasis size-5 fill-current' : 'size-5'} />
    </Button>
  );
}
